export const CREATE_SA_VIEW_NAME = "create_search_analytics_view";
export const CREATE_SA_VIEW_DESC = `Creates a Search Analytics View under a Search Analytics project.

Use when the user asks to save conditions/filters as a reusable Search Analytics view.

Input (one of 'projectId' or 'searchAnalyticsId' is required):
- 'projectId': Search Analytics Project ID. The tool resolves the Search Analytics ID from it.
- 'searchAnalyticsId': Search Analytics ID directly.
- 'name' (required): View name.
- Optional filters: description, query(+type), queryGroupIDs, url(+type), urlGroupIDs, devices, countries, searchTypes, rawKinds, rawKindsNot, isAnonymousQuery.
- Optional 'dataDate': { type: LATEST|DAYS_7|DAYS_14|DAYS_28|DAYS_90|DAYS_180|DAYS_365|DAYS_480|CUSTOM, dateRange?: { start, end } }.

Notes:
- Write operation (mutation). Returns the created view's basic fields, plus 'projectId', 'searchAnalyticsId', and link field 'viewUrl' (absolute when available).
- You don't need to show IDs like project ID or search analytics ID to the user. User will only see the view name and URL.

Defaults:
- searchTypes defaults to [WEB] when not specified.
- rawDataGroupBy defaults to [QUERY, QUERY_GROUP, URL, URL_GROUP] and can be overridden.`;
